// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionList-module__root--KpERi {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}

.OptionList-module__shape-default--T7RZC,
.OptionList-module__shape-normal--UMppJ {
  width: 100%;
}

.OptionList-module__title--MikVM {
  box-sizing: border-box;
  padding: 6px 0 1px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 1.3125rem; /* 21px */
  font-weight: 400;
  line-height: 31.5px;
  letter-spacing: -1.0589px;
  overflow-wrap: break-word;
}

.OptionList-module__ui-OptionList-Item--pn2vI {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 34px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #ddd;
  color: var(--chaek-color-text-muted);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
  overflow-wrap: break-word;
  cursor: pointer;
}

.OptionList-module__ui-OptionList-Item--pn2vI.OptionList-module__is-active--Z06vH {
  border-bottom: 2px solid var(--chaek-color-border-strong);
  color: var(--chaek-color-text-primary);
}

.OptionList-module__content--V1D6R {
  display: inline-block;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: normal;
  flex: 1;
}

.OptionList-module__meta--Xvplm {
  display: inline-block;
  color: var(--chaek-color-text-muted);
  font-size: 0.625rem; /* 10px */
  font-weight: 400;
  line-height: 15px;
  letter-spacing: -0.2328px;
}

.OptionList-module__ui-OptionList-Item--pn2vI.OptionList-module__is-active--Z06vH .OptionList-module__meta--Xvplm {
  color: var(--chaek-color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/OptionList/OptionList.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;EACjD,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,iDAAiD;EACjD,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 16px;\n}\n\n.shape-default,\n.shape-normal {\n  width: 100%;\n}\n\n.title {\n  box-sizing: border-box;\n  padding: 6px 0 1px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 1.3125rem; /* 21px */\n  font-weight: 400;\n  line-height: 31.5px;\n  letter-spacing: -1.0589px;\n  overflow-wrap: break-word;\n}\n\n.ui-OptionList-Item {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: 34px;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px;\n  border-bottom: 1px solid #ddd;\n  color: var(--chaek-color-text-muted);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n  overflow-wrap: break-word;\n  cursor: pointer;\n}\n\n.ui-OptionList-Item.is-active {\n  border-bottom: 2px solid var(--chaek-color-border-strong);\n  color: var(--chaek-color-text-primary);\n}\n\n.content {\n  display: inline-block;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: normal;\n  flex: 1;\n}\n\n.meta {\n  display: inline-block;\n  color: var(--chaek-color-text-muted);\n  font-size: 0.625rem; /* 10px */\n  font-weight: 400;\n  line-height: 15px;\n  letter-spacing: -0.2328px;\n}\n\n.ui-OptionList-Item.is-active .meta {\n  color: var(--chaek-color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OptionList-module__root--KpERi`,
	"shape-default": `OptionList-module__shape-default--T7RZC`,
	"shape-normal": `OptionList-module__shape-normal--UMppJ`,
	"title": `OptionList-module__title--MikVM`,
	"ui-OptionList-Item": `OptionList-module__ui-OptionList-Item--pn2vI`,
	"is-active": `OptionList-module__is-active--Z06vH`,
	"content": `OptionList-module__content--V1D6R`,
	"meta": `OptionList-module__meta--Xvplm`
};
export default ___CSS_LOADER_EXPORT___;
